import axios, { AxiosResponse } from 'axios';
import { TopConfig } from '../context/ConfigContext';
import { StageFileResponse } from '../types/services';

export const stageFiles = async (topConfig: TopConfig, taskIds: string[]) => {
    try {
        const isLoggedOn = window.topContext.user.isLoggedOn;
        const dscmNumber = window.topContext.config.getSiteConfig().environment;

        const { services, uploadClientId } = topConfig;
        const { open, close } = services.stageFiles;

        const requestConfig = isLoggedOn ? close : open;

        const response: AxiosResponse<StageFileResponse[]> = await axios({
            ...requestConfig,
            headers: {
                ...requestConfig.headers,
                'x-top-dscm': dscmNumber
            },
            data: {
                taskIds: taskIds,
                clientId: uploadClientId
            }
        });

        // API response:
        // 200 | array
        // 204 | empty string

        // return array of staged files or an empty array if no files have been staged
        return response.status === 200 ? response.data : [];
    } catch (error) {
        throw new Error(`Failed to stage files - ${JSON.stringify(error)}`);
    }
};
